<script lang="ts">
  import { intersection, map, without } from 'lodash-es'
  import { onChange } from '#app/lib/svelte/svelte'
  import FacetSelector from '#general/components/facet_selector.svelte'
  import type { EntityUri } from '#server/types/entity'
  import { I18n } from '#user/lib/i18n'

  let {
    sectionName,
    facetsSelectors = $bindable(),
    facetsSelectedValues = $bindable(),
    intersectionWorkUris,
  }: {
    sectionName: string
    facetsSelectors
    facetsSelectedValues
    intersectionWorkUris: EntityUri[]
  } = $props()

  const options = $derived(facetsSelectors[sectionName].options)

  const displayedOptions = $derived.by(() => {
    if (intersectionWorkUris) {
      return options.filter(option => option.intersection.length > 0)
    } else {
      return options
    }
  })
  const optionsCount = $derived(without(map(displayedOptions, 'value'), 'unknown').length)

  function refreshIntersection (option) {
    if (intersectionWorkUris) {
      option.intersection = intersection(option.worksUris, intersectionWorkUris)
    } else {
      option.intersection = option.worksUris
    }
    option.count = option.intersection.length
  }

  function filterOptions () {
    options.forEach(refreshIntersection)
  }
  $effect(() => {
    onChange(intersectionWorkUris, filterOptions)
  })
</script>

<FacetSelector
  bind:value={facetsSelectedValues[sectionName]}
  {displayedOptions}
  {optionsCount}
  buttonLabel={I18n(sectionName)}
/>
